<template>
    <div class="buyer">
        <div class="lestNav" :style="{ minHeight: height + 'px' }">
            <span v-for="(item,index) in menuList" :key="index" :class="{ active:index==activeIndex }" @click="getDetail(index,item)">{{ item.label }}</span>
        </div>  
        <div class="main-content" :style="{ minHeight: height + 'px' }">
            <div class="user-nav">
                <span class="active" @click="$router.push('/buyer-manage')">我要投资</span>
                <span @click="$router.push('/seller-manage')">我要出让</span>
                <span @click="$router.push('/user')">用户管理</span>
            </div>
            <router-view></router-view>
        </div>      
    </div>
</template>
<script>
const menuList = [
                  {label:'供求信息委托',router:'/buyer-manage'},
                  {label:'项目挂牌订单',router:'/buyer-gp'},
                  {label:'项目竞价订单',router:'/itemOrder'},
                  {label:'已报名竞价',router:'/bidded'},
                  {label:'竞价报名管理',router:'/biddedManege'},
                  {label:'申诉结果',router:'/buyerComplain'},
                  {label:'我的合同',router:'/buyerContract'},
                  {label:'订单上链订单',router:'buyer-itemSlOrder'},
                  {label:'上链查询',router:'buyer-itemSl'}
                ]
export default {
   data(){
       return{
          menuList:menuList,
          height:'',
          activeIndex:0
       }
   },
   mounted(){
       this.height = document.body.clientHeight - 85;
   },
   methods:{
        getDetail(index,item){
            this.activeIndex = index;
            this.$router.push(item.router);
        }
   }
}
</script>

<style lang="less" scoped>
.buyer{
    width: 1300px;
    margin:0 auto;
    background: #fff;
    display: flex;
    .lestNav{
        display: flex;
        flex-direction: column;
        width: 200px;
        border-right:10px solid #f0f2f5;
        cursor: pointer;
        span{
            line-height: 50px;
            padding-left: 20px;
            border-bottom: 1px solid #eeeeee;
        }
        .active{
            background: #1890ff;
            color: #fff;
        }
    }
    .main-content{
        width: 1090px;
    }
}
</style>